webpackJsonp([2],{

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsoneditor_dist_jsoneditor_min__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsoneditor_dist_jsoneditor_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsoneditor_dist_jsoneditor_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsoneditor_dist_jsoneditor_min_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsoneditor_dist_jsoneditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsoneditor_dist_jsoneditor_min_css__);

// https://github.com/josdejong/jsoneditor/blob/master/docs/api.md



var modes = ['tree', 'view', 'form', 'code', 'text'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-jsoneditor',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      jsoneditor: null
    };
  },

  watch: {
    value: function value(_value) {
      this.jsoneditor.set(_value);
    }
  },
  methods: {
    getOptions: function getOptions() {
      var defaults = {
        escapeUnicode: false,
        history: true,
        indentation: 2,
        mode: modes[0],
        modes: modes.slice(0),
        navigationBar: true,
        search: true,
        statusBar: true,
        sortObjectKeys: false
      };

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaults, this.options, {
        onChange: this.onChange,
        onError: this.onError
      });
    },
    onChange: function onChange() {
      try {
        var value = this.jsoneditor.get();
        this.$emit('input', value);
        // eslint-disable-next-line
      } catch (e) {}
    },
    onError: function onError(error) {
      this.$emit('error', error);
    }
  },
  render: function render(h) {
    return h('div', {
      ref: 'jsoneditor'
    });
  },
  mounted: function mounted() {
    this.jsoneditor = new __WEBPACK_IMPORTED_MODULE_1_jsoneditor_dist_jsoneditor_min___default.a(this.$refs.jsoneditor, this.getOptions(), this.value);

    this.onChange();
  },
  beforeDestroy: function beforeDestroy() {
    this.jsoneditor.destroy();
    this.jsoneditor = null;
  }
});

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VJsoneditor__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_VJsoneditor__["a" /* default */]);

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VJsoneditor__ = __webpack_require__(23);


__WEBPACK_IMPORTED_MODULE_0__VJsoneditor__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VJsoneditor__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VJsoneditor__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VJsoneditor__["a" /* default */]);

/***/ })

},[55]);


// WEBPACK FOOTER //
// docs/js/vjsoneditor.9a50c4fb63fe01a03019.js